import _ from 'lodash';
import { Injectable } from '@angular/core';
import { CampaignOptionListEventHandlerService } from './campaign-option-list-event-handler.service';
import { CampaignOptionEventHandlerService } from './campaign-option-event-handler.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignOptionListService {

    private _list: any[] = [];
    set list(list: any[]) {
      this._list = list;
      this._activeList = list.filter(option => {
        switch(option.data.status) {
          case 0:
          case 2:
          case 3:
          case 4:
            return true;
        }
        return false;
      });
      this.campaignOptionListEventHandlerService.onUpdateCampaignOptionList.next(this._list);
    }
    get list() {
      return this._list;
    }

    private _activeList: any[] = [];
    set activeList(activeList: any[]) {
      this._activeList = activeList;
    }
    get activeList() {
      return this._activeList;
    }

    private _search: string = '';
    set search(search: string) {
      this._search = search;
      this.campaignOptionListEventHandlerService.onSearchCampaignOptionList.next(search);
    }
    get search() {
      return this._search;
    }

    private _selected: any[] = [];
    set selected(selected: any[]) {
      this._selected = selected;
      this.campaignOptionEventHandlerService.onSelectCampaignOption.next(selected);
    }
    get selected() {
      return this._selected;
    }

    constructor(
      public campaignOptionListEventHandlerService: CampaignOptionListEventHandlerService,
      public campaignOptionEventHandlerService: CampaignOptionEventHandlerService
    ) { }

    onUpdateList() {
      this.campaignOptionListEventHandlerService.onUpdateCampaignOptionList.next(this.list);
    }

    getActiveListBySearch() {
      const activeOptionList = this.list.filter(option => {
        switch(option.data.status) {
          case 0:
          case 2:
          case 3:
          case 4:
            return true;
        }
        return false;
      });

      return _.filter(activeOptionList, ({ data }) => {
        const name = _.chain(data)
            .get('name', '')
            .lowerCase()
            .value();
        const desc = _.chain(data)
            .get('desc', '')
            .lowerCase()
            .value();
        const value = _.chain(this.search)
            .lowerCase()
            .value();
        return _.includes(name, value) || _.includes(desc, value);
      });
    }

    getDeletedListBySearch() {
      const deletedOptionList = this.list.filter(option => {
        switch(option.data.status) {
          case 0:
          case 2:
          case 3:
          case 4:
            return true;
        }
        return false;
      });

      return _.filter(deletedOptionList, ({ data }) => {
        const name = _.chain(data)
            .get('name', '')
            .lowerCase()
            .value();
        const value = _.chain(this.search)
            .lowerCase()
            .value();
        return _.includes(name, value);
      });
    }

    reset() {
        this.list = [];
        this.search = '';
        this.selected = null;
    }

}
